export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    salesList: [
      {
        salesIdx: 1,
        orderIdx: 1,
        name: "홍길동",
        personnel: 5,
        menuArr: [
          {
            discount: 500,
            groupIdx: 1,
            menuIdx: 2,
            name: "02 Garlic paghetti",
            optionList: [
              {
                selectItemCd: "10000147",
                selectItemCnt: 1,
                selectItemDiscount: 0,
                selectItemNm: "XL 사이즈",
                selectItemPrice: 3000,
              },
            ],
            price: 18500,
            qty: 1,
          },
        ],
        salesDate: "2023-11-21",
        salesTime: "12:56:24",
      },
      {
        salesIdx: 2,
        orderIdx: 2,
        name: "숭흠1",
        personnel: 4,
        menuArr: [
          {
            discount: 5000,
            groupIdx: 1,
            menuIdx: 2,
            name: "02 Garlic paghetti",
            optionList: [
              {
                selectItemCd: "10000147",
                selectItemCnt: 1,
                selectItemDiscount: 0,
                selectItemNm: "XL 사이즈",
                selectItemPrice: 3000,
              },
            ],
            price: 14000,
            qty: 1,
          },
        ],
        salesDate: "2023-11-21",
        salesTime: "16:16:12",
      },
      {
        salesIdx: 3,
        orderIdx: 3,
        name: "숭흠2",
        personnel: 9,
        menuArr: [
          {
            discount: 0,
            groupIdx: 1,
            menuIdx: 2,
            name: "02 Garlic paghetti",
            optionList: [
              {
                selectItemCd: "10000147",
                selectItemCnt: 1,
                selectItemDiscount: 0,
                selectItemNm: "XL 사이즈",
                selectItemPrice: 3000,
              },
            ],
            price: 11000,
            qty: 1,
          },
        ],
        salesDate: "2023-11-20",
        salesTime: "11:11:12",
      },
    ],
  },
};
